import TechnologyPageIntro from '../../organisms/TechnologyPageIntro/TechnologyPageIntro'
import CloudDevopsService from '../../atoms/CloudDevopsService/CloudDevopsService'
import CommanFooterCard from '../../atoms/CommanFooterCard/CommanFooterCard'
import Testimonial from '../../molecules/Testimonial/Testimonial'
import Message from '../../molecules/Message/Message'
import Questions from '../../molecules/Questions/Questions'
import Footer from '../../organisms/Footer/Footer'
import Constants from '../../../app/utils/constants'
import commonfooter from '../../../assets/images/commonfooter.webp'

const cloudDevopsIntro = Constants.cloudDevopsPageIntro
const cloudDevopsScrollWords = Constants.cloudDevopsItems.map((item) => item.name)

const CloudDevopsPage = () => {
  return (
    <main className="min-h-screen bg-[#0E0924] text-white">
      <TechnologyPageIntro {...cloudDevopsIntro} scrollBannerText={cloudDevopsScrollWords} />
      <CloudDevopsService />
      <CommanFooterCard
 paragraph="We believe in giving back. Our team contributes to open source projects and shares knowledge through blog posts, conference talks, and community events."
imageSrc={commonfooter}
imageAlt="About us leadership profile"
overlayGradient="linear-gradient(0deg, #874bff7d 17.11%, rgba(135, 75, 255, 0) 100%)"
/>
      <Testimonial className="mx-auto mb-20 max-w-[90%]" showHeader />
      <div className="mb-10 px-4 md:px-8 2xl:mx-20 xl:px-12">
      <div className="grid w-full grid-cols-1 gap-5 xl:min-h-[620px] 2xl:min-h-[710px] lg:grid-cols-[1fr_1fr] xl:grid-cols-[1fr_2fr]">
          <Message />
          <Questions />
        </div>
      </div>
      <Footer />
    </main>
  )
}

export default CloudDevopsPage
